// Independent page composition for Software Platform Refactoring.
const { h, PageFrame, section, split, context, deliverables, scenario, answer, scope, diagram } = require('../pageParts');
module.exports = function PlatformRefactoringPage({ service }) {
  return h(PageFrame, { service, tone: 'split', hero: diagram(service, 'flow') },
    section('A practical approach to your business requirements', context(service), { className: 'ai-narrow-section' }),
    section('What the engagement can include', split(deliverables(service, 'timeline'), scenario(service)), { theme: 'ai-wash' }),
    section(null, split(answer(service), scope()))
  );
};
